import React from 'react';
import './SearchToolbar.css';

/* Línea compacta de filtros activos (F2, brief §7): SOLO se renderiza cuando
   hay filtros aplicados — nunca una franja vacía de ancho completo.
   "Limpiar todo" visible únicamente aquí (o sea, solo con filtros activos). */
export default function ActiveFilterChips({ chips = [], onRemove, onClearAll, className = '' }) {
  if (!chips.length) return null;
  return (
    <div className={`ui-active-chips${className ? ` ${className}` : ''}`}>
      <span className="ui-active-chips-label">Filtros activos:</span>
      {chips.map((c) => (
        <span key={c.id} className="ui-active-chip">
          {c.label}
          <button type="button" aria-label={`Quitar filtro ${c.label}`} onClick={() => onRemove?.(c.id)}>×</button>
        </span>
      ))}
      {onClearAll && (
        <button type="button" className="ui-active-chips-clear" onClick={onClearAll}>Limpiar todo</button>
      )}
    </div>
  );
}
